import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const ReporteGeneral = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.post(`/movimientos-inventario/reportes/general`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        reporteGeneralMutation: mutation.mutate,
    };
}
export const ReporteIndividual = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.post(`/movimientos-inventario/reportes/general/individual`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        reporteIndividualMutation: mutation.mutate,
    };
}